import { ListAgenticLogicRulesWithDeploysResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const listAgenticLogicRules = async () => {
  const resp = await api.get<ListAgenticLogicRulesWithDeploysResponseBodyType>(
    `/v2/agentic-logic/rules`
  );
  return resp.data;
};

/**
 * Lists every Agentic Logic rule in the org. The endpoint is unpaginated and
 * unsorted, so consumers sort and filter client-side.
 */
export const useAgenticLogicRules = () => {
  return useQuery<ListAgenticLogicRulesWithDeploysResponseBodyType, Error>({
    queryKey: agenticLogicKeys.rules(),
    queryFn: async () => listAgenticLogicRules(),
    // The rule list is server-mutable behind this client's back: the publish
    // worker flips draft -> active minutes after the chat hands off, and
    // another tab or user can pause or delete at any time. Under the app-wide
    // 24h staleTime a mounted page would keep offering a snapshot forever, so
    // the binding picker would offer rules that no longer serve and withhold
    // ones that do. Opting out here — the one place that owns this key — keeps
    // the escape hatch scoped to the query that needs it.
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });
};
